export default (state, subjectAbr) => {
  const measures = state.fullListOfMeasures;

  return measures.filter((measure) => measure.s_id === subjectAbr)[0].lvl;
};
